<div *ngIf="trocandofornecedor" class="loading-overlay">
    <app-view-loading></app-view-loading>
</div>
<div class="container">
    <div class="filters" *ngIf="!exibirMapaComponent">
        <h4>{{"Filtrar e Ordenar" | translate }}</h4>
        <div class="input">
            <h6>{{"Pesquisar" | translate}}</h6>
            <input id="nome_Hotel_Search" [(ngModel)]="FiltroHotel.Nome" value="" type="text" class="form-control"
                placeholder="{{'Nome do Hotel' | translate}}">
        </div>
        <div class="filto-hotel mt-4">
            <div class="rating-css">
                <p>{{"Classificação" | translate}}</p>
                <form class="form-inline slider-classificacao">
                    <ngx-slider [(value)]="FiltroHotel.EstrelasMinimo" [(highValue)]="FiltroHotel.EstrelasMaximo"
                        [options]="OpcoesClassificacao" (userChangeEnd)="buscarDebounce()"></ngx-slider>
                </form>
            </div>
            <div class="faixa-preco-hotel mt-2">
                <p>{{"Preço" | translate}}</p>
                <form class="form-inline">
                    <ngx-slider [(value)]="FiltroHotel.ValorMinimo" [(highValue)]="FiltroHotel.ValorMaximo"
                        [options]="OpcoesValor" (userChangeEnd)="buscarDebounce()"></ngx-slider>
                </form>
            </div>
            <div class="faixa-preco-hotel mt-2">
                <p>{{"Mostrar" | translate}}?</p>
                <select class="form-control" placeholder="Selecione" (change)="refazerBusca(busca)"
                    [(ngModel)]="FiltroHotel.Reembolsavel" name="reembolsavel" style="min-width: 200px">
                    <option value="-1">{{'Todos' | translate}}</option>
                    <option value="1">{{'Reembolsavel' | translate}}</option>
                    <option value="0">{{'Não' | translate}} {{'Reembolsavel' | translate}}
                    </option>
                </select>
            </div>
            <div class="faixa-preco-hotel mt-2" *ngIf="busca.usuario.EmpresaId != null">
                <p>{{"Fornecedores" | translate}}</p>
                <div *ngFor="let fornecedor of Fornecedores; let k = index">
                    <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="fornecedor-{{fornecedor}}"
                            name="fornecedor-{{fornecedor}}" (change)="selecionarFornecedor(fornecedor)"
                            [checked]="FornecedorSelecionado(fornecedor)" />
                        <label class="form-check-label" for="fornecedor-{{fornecedor}}">{{fornecedor}} </label>
                    </div>
                </div>
            </div>
            <div class="faixa-preco-hotel mt-2">
                <p>{{"Pensões" | translate}}</p>
                <div style="height: 300px; overflow-x: auto;">
                    <div *ngFor="let pensao of FiltroHotel.Pensoes; let k = index">
                        <div class="form-check">
                            <input type="checkbox" class="form-check-input" id="pensao-{{pensao}}"
                                name="pensao-{{pensao}}" (change)="selecionarPensao(pensao)"
                                [checked]="pensaoSelecionada(pensao)" />
                            <label class="form-check-label" for="pensao-{{pensao}}">{{pensao}} </label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="filterButton">
                <button (click)="refazerBusca(busca)" type="button" class="btn btn-success">{{"Filtrar" |
                    translate}}</button>
            </div>
        </div>
    </div>
    <div class="resultList">
        <div *ngIf="carregando">
            <app-view-loading></app-view-loading>
        </div>
        <div class="row" *ngIf="buscando">
            <div class="col-12 row flex-row">
                <ng-container *ngFor="let integrador of buscasAtivas">
                    <div class="mt-1 mb-3 col-2 d-inline-flex justify-content-center align-items-center">
                        <p class="mb-0">{{ integrador }}</p>
                        <img src="assets/img/loading1.gif" />
                    </div>
                </ng-container>
            </div>
        </div>
        <div class='row nav-options' *ngIf="!carregando && !buscando">
            <div class="col col-md-3 p-0">
                <button class="w-100 btn btn-primary" [disabled]="buscando || hoteis.length == 0"
                    [style]="exibirMapaComponent && !buscando ? 'background-color: #FF0000' : ''"
                    (click)="toogleMap(!exibirMapaComponent)">
                    {{exibirMapaComponent && !buscando ? 'Fechar Mapa' : 'Abrir Mapa'}}
                </button>
            </div>
            <div *ngIf="busca.usuario.EmpresaId != null" class="col col-md-3 p-0 ms-auto">
                <button class="w-100 btn btn-primary" (click)="abrirModalFornecedores(contentFornecedores)">
                    {{'Fornecedores'}}
                </button>
            </div>
            <div class='col text-end p-0' [hidden]="buscando || (Orcamento.length == 0)">
                <button [disabled]="buscando || (Orcamento.length == 0)"
                    class="btn btn-success d-flex justify-content-center align-items-center ms-auto"
                    (click)="rotaAvancar()">
                    <a>{{"Avançar" | translate}}<i class="fas fa-chevron-right ms-2"></i></a>
                </button>
            </div>
        </div>
        <div *ngIf="!carregando && !exibirMapaComponent">
            <div class="theme-search-results-item _mb-10 theme-search-results-item-rounded theme-search-results-item-"
                *ngFor="let hotel of hoteis, let i = index">
                <div *ngIf="hotel.AgrupamentoFornecedor?.length>1">
                    <button [disabled]="buscando" *ngFor="let agrupador of hotel.AgrupamentoFornecedor; let k = index"
                        class="btn btn-success btn-round btn-sm mb-2 mr-1" style="margin-right: 5px;"
                        (click)="trocarHotelFornecedor(agrupador,hotel)">{{(busca.usuario.EmpresaId !=
                        null?agrupador.Fornecedor:k+1)}}</button>
                </div>
                <app-hotel
                    [politicaListagem]="{hotelId: hotel.Id, agenciaId: busca.AgenciaId, guid: busca.guid, listagem: true}"
                    [hotel]="hotel" [usuario]="busca.usuario" [carregando]="buscando"
                    (selecionouHotel)="selecionarHotel($event)" (removeuHotel)="removerHotel($event)"></app-hotel>
            </div>
            <p *ngIf="hoteis.length == 0 && !buscando">{{"Esta busca não retornou nenhum resultado." | translate}}
            </p>
            <div class="justify-content-center col-md-12 col-lg-12 col-xxxl-12">
                <app-paginacao [paginacao]="paginacao" (alterarPagina)="buscarPagina($event)"></app-paginacao>
            </div>
        </div>

        <div class="card " *ngIf="exibirMapaComponent && !carregando && !buscando">
            <div class="card-body row d-flex justify-content-center">
                <app-hotel-mapa class="col-12 mt-2" [busca]="busca" [guid]="guidBuscaMapa"
                    (selecionouHotel)="selecionarHotel($event)" (removerHotel)="removerHotel($event)"
                    (trocarHotelFornecedorEmitter)="trocarHotelFornecedor($event.agrupador,$event.hotel)"
                    (rebuscar)="rebuscaViaMapa()"></app-hotel-mapa>
            </div>
        </div>
    </div>
</div>

<ng-template #contentFornecedores let-modal>
    <app-lista-fornecedores [infoFornecedores]="infoFornecedores"></app-lista-fornecedores>
</ng-template>